import { formatCivilDate } from './dateTime'

const TransformDate = datetime => formatCivilDate(datetime)

export default TransformDate